// QualiApps site v2 — boot.

import './styles/tokens.css';
import './styles/base.css';
import './styles/typography.css';
import './styles/layout.css';
import './styles/hero.css';
import './styles/familia.css';
import './styles/estimator.css';
import './styles/services.css';
import './styles/about.css';
import './styles/process.css';
import './styles/qualiobra-feat.css';
import './styles/portfolio.css';
import './styles/team.css';
import './styles/testimonials.css';
import './styles/aulas-feat.css';
import './styles/faq.css';
import './styles/contact.css';

import { initTheme } from './lib/theme';
import { initI18n } from './lib/i18n';
import { bindI18nAutoApply } from './lib/i18n-dom';
import { initHeader } from './modules/header';
import { initMobileMenu } from './modules/mobile-menu';
import { initThemeToggle } from './modules/theme-toggle';
import { initLanguageToggle } from './modules/language-toggle';
import { initPrivacyModal } from './modules/privacy-modal';
import { initHeroParallax } from './modules/hero-parallax';
import { initFamiliaRoleta } from './modules/familia-roleta';
import { initReveal } from './modules/reveal';
import { initEstimatorChat } from './modules/estimator-chat';
import { initPortfolioCarousel } from './modules/portfolio-carousel';
import { initContactForm } from './modules/contact-form';

initTheme();
initHeader();
initMobileMenu();
initPrivacyModal();
initHeroParallax();
initReveal();
initPortfolioCarousel();

void initI18n().then(() => {
  bindI18nAutoApply();
  initThemeToggle();
  initLanguageToggle();
  // Familia + Estimator dependem de t() para greets e textos dinâmicos.
  initFamiliaRoleta();
  initEstimatorChat();
  initContactForm();
});

// Year stamp no footer
const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());

export {};
